const sessionActionTypes = {
	setUserInfo: 'SET_USER_INFO',
	resetUserInfo: 'RESET_USER_INFO',
	updatePathologyUser: 'UPDATE_PATHOLOGY_USER',
	setPatientUser: 'SET_PATIENT_USER',
	updatePatientToUser: 'UPDATE_PATIENT_TO_USER',
	updateAllPatientsToUser: 'UPDATE_ALL_PATIENTS_TO_USER',
	setServiceUser: 'SET_USER_SERVICES',
	deletePatientUser: 'DELETE_PATIENT_USER',
	activeSubscription: 'ACTIVE_SUBSCRIPTION',
	setResourcesUser: 'SET_RESOURCES_USER'
}

export default sessionActionTypes
